import IntegrationModals from './IntegrationModals'

export default IntegrationModals
export { default as useIntegrationModals, MODALS, ACTIONS, ACTION_TO_MODAL } from './useIntegrationModals'
